import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-thirdparty-create-thirdpartycontract-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class ThirdpartyContractCreateApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.createNewThirdPartyContract"),
            description: this.translation.t("specs.createNewThirdPartyContractDescription"),
            httpMethod: "POST",
            path: "/thirdpartycontract",

            parameters: [
                {
                    name: "Contractnumber",
                    description: this.translation.t("parameters.thirdPartyContractnumberDescription"),
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "third party contract to create contract number",
                },
                {
                    name: "ContractedValue",
                    description: this.translation.t("parameters.thirdPartyContractedValueDescription"),
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 12345,
                },
                {
                    name: "StatusId",
                    description: this.translation.t("parameters.thirdPartyStatusIdDescription"),
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1,
                },
                {
                    name: "TermOfNoticeQuantity",
                    description: this.translation.t("parameters.thirdPartyTermOfNoticeQuantityDescription"),
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 3,
                },
                {
                    name: "TermOfNoticePeriod",
                    description: this.translation.t("parameters.thirdPartyTermOfNoticePeriodDescription"),
                    in: "body",
                    paramType: "integer",
                    required: true,
                    example: 1,
                },
                {
                    name: "SignatureDate",
                    description: this.translation.t("parameters.thirdPartySignatureDateDescription"),
                    in: "body",
                    paramType: "date",
                    required: false,
                    example: "2025-01-31",
                },
                {
                    name: "StartDate",
                    description: this.translation.t("parameters.thirdPartyStartDateDescription"),
                    in: "body",
                    paramType: "date",
                    required: false,
                    example: "2025-02-01",
                },
                {
                    name: "EndDate",
                    description: this.translation.t("parameters.thirdPartyEndDateDescription"),
                    in: "body",
                    paramType: "date",
                    required: false,
                    example: "2025-02-28",
                },
                {
                    name: "AnnualValue",
                    description: this.translation.t("parameters.thirdPartyAnnualValueDescription"),
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1234567890,
                },
                {
                    name: "Framework",
                    description: this.translation.t("parameters.thirdPartyFrameworkDescription"),
                    in: "body",
                    paramType: "boolean",
                    required: false,
                    example: true,
                },
                {
                    name: "ThirdPartyGuid",
                    description: this.translation.t("parameters.thirdPartyGuidDescription"),
                    in: "body",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "ContractOwner",
                    description: this.translation.t("parameters.thirdPartyContractOwnerDescription"),
                    in: "body",
                    paramType: "uuid",
                    required: false,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "CurrencyCode",
                    description: this.translation.t("parameters.thirdPartyCurrencyCodeDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "EUR",
                },
                {
                    name: "Services",
                    description: this.translation.t("parameters.thirdPartyServicesDescription"),
                    in: "body",
                    paramType: "array of integers",
                    required: false,
                    example: [1, 2],
                },
                {
                    name: "CustomFields",
                    description: this.translation.t("parameters.thirdPartyCustomFieldsDescription"),
                    in: "body",
                    paramType: "array of models",
                    required: false,
                    example: [
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000000",
                            Value: "1,2",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000001",
                            Value: "1",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000002",
                            Value: "api custom field text",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000004",
                            DateValue: "2025-03-15",
                        },
                    ],
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],
        };
    }
}
